import Moderate from './moderate';
import Steps from './steps';

export default {
  Moderate, Steps
};



// WEBPACK FOOTER //
// ./src/components/modals/moderate/index.js